import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58f6fb47"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: { width: '100%', fontSize: '0.8rem' } }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center",
  width: "30"
}, "TT", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "2",
  class: "text-center break-word",
  width: "160"
}, "Định mức, BBGT", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center",
  width: "55"
}, "Mã VT", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center break-word",
  width: "210"
}, "Tên vật tư", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center",
  width: "90"
}, "Đặc tính", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center break-word",
  width: "50"
}, "ĐVT", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center break-word",
  width: "70"
}, "Đơn giá", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "text-center",
  width: "45"
}, "Số", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "text-center",
  width: "115"
}, "Ngày", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "text-center",
  width: "80"
}, "Số lượng", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "text-center",
  width: "80"
}, "Thành tiền", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "A"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "B"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "C"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "D"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "E"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "F"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "G"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "1"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "2"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "3 = 1 * 2"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "4"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "5 = 1 * 4"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "6 = 4 - 2"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "7 = 1 * 6")
], -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "14",
  class: "text-center fst-italic"
}, "Không có dữ liệu", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "text-end" }
const _hoisted_19 = { class: "break-word" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = { class: "text-end" }
const _hoisted_23 = { class: "text-end fw-bolder" }
const _hoisted_24 = { class: "text-end" }
const _hoisted_25 = { class: "text-end fw-bolder" }
const _hoisted_26 = { class: "text-end" }
const _hoisted_27 = { class: "text-end fw-bolder" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bolder text-center",
  colspan: "7"
}, "Cộng", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_31 = { class: "text-end fw-bolder" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_33 = { class: "text-end fw-bolder" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_35 = { class: "text-end fw-bolder" }

import { computed, PropType } from 'vue';
import { IChiTietXuatTheoDoiTuongResponseBase } from "@/core/interfaces/ApiResponses";
import { formatCurrencyAndQuantity } from '@/core/helpers/utils';
import { useDateTime } from "@/core/hooks/use-date-time-hook";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChiTietXuatTheoDoiTuongTable',
  props: {
  items: {
    type: Array as PropType<IChiTietXuatTheoDoiTuongResponseBase[]>,
    required: true,
  }
},
  setup(__props) {

const { formatDisplayingDate } = useDateTime();

const props = __props;

const totalThanhTien = computed(() => {
  const result = {
    theo_dinh_muc: 0,
    thuc_hien: 0,
    chenh_lech: 0,
  };

  props.items?.forEach(({
    thanh_tien_dinh_muc_co_dinh,
    thanh_tien_chenh_lech,
    don_gia_thuc_hien,
    so_luong_thuc_hien,
  }) => {
    result.theo_dinh_muc += +thanh_tien_dinh_muc_co_dinh;

    result.thuc_hien += +don_gia_thuc_hien * +so_luong_thuc_hien;

    result.chenh_lech += +thanh_tien_chenh_lech;
  });

  return {
    theo_dinh_muc: formatCurrencyAndQuantity(Math.round(result.theo_dinh_muc), false),
    thuc_hien: formatCurrencyAndQuantity(Math.round(result.thuc_hien), false),
    chenh_lech: formatCurrencyAndQuantity(Math.round(result.chenh_lech), false),
  };
})

const columnArr = ['Theo định mức', 'Thực hiện', 'Chênh lệch']

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("tr", null, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columnArr, (header, index) => {
        return _createElementVNode("th", {
          key: index,
          colspan: "2",
          class: "text-center",
          width: "160"
        }, _toDisplayString(header), 1)
      }), 64))
    ]),
    _createElementVNode("tr", null, [
      _hoisted_9,
      _hoisted_10,
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: n }, [
          _hoisted_11,
          _hoisted_12
        ], 64))
      }), 64))
    ]),
    _hoisted_13,
    (!__props.items.length)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_14, _hoisted_16))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_17, _toDisplayString(index + 1), 1),
              _createElementVNode("td", _hoisted_18, _toDisplayString(item.so_bien_ban_giai_the), 1),
              _createElementVNode("td", null, _toDisplayString(_unref(formatDisplayingDate)(new Date(item.ngay_lap))), 1),
              _createElementVNode("td", null, _toDisplayString(item.ma_vat_tu), 1),
              _createElementVNode("td", _hoisted_19, _toDisplayString(item.ten_vat_tu), 1),
              _hoisted_20,
              _createElementVNode("td", null, _toDisplayString(item.don_vi_tinh), 1),
              _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(formatCurrencyAndQuantity)(+item.don_gia_thuc_hien)), 1),
              _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(formatCurrencyAndQuantity)(+item.so_luong_dinh_muc)), 1),
              _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(formatCurrencyAndQuantity)(+item.thanh_tien_dinh_muc_co_dinh, false)), 1),
              _createElementVNode("td", _hoisted_24, _toDisplayString(_unref(formatCurrencyAndQuantity)(+item.so_luong_thuc_hien)), 1),
              _createElementVNode("td", _hoisted_25, _toDisplayString(_unref(formatCurrencyAndQuantity)(
              +item.don_gia_thuc_hien * +item.so_luong_thuc_hien,
              false,
            )), 1),
              _createElementVNode("td", _hoisted_26, _toDisplayString(_unref(formatCurrencyAndQuantity)(+item.so_luong_chenh_lech)), 1),
              _createElementVNode("td", _hoisted_27, _toDisplayString(_unref(formatCurrencyAndQuantity)(
              +item.thanh_tien_chenh_lech,
              false,
            )), 1)
            ]))
          }), 128)),
          _createElementVNode("tr", null, [
            _hoisted_28,
            _hoisted_29,
            _hoisted_30,
            _createElementVNode("td", _hoisted_31, _toDisplayString(totalThanhTien.value.theo_dinh_muc), 1),
            _hoisted_32,
            _createElementVNode("td", _hoisted_33, _toDisplayString(totalThanhTien.value.thuc_hien), 1),
            _hoisted_34,
            _createElementVNode("td", _hoisted_35, _toDisplayString(totalThanhTien.value.chenh_lech), 1)
          ])
        ], 64))
  ]))
}
}

})